import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AdContainer } from "@/ads/components/AdContainer";
import { useRefsContext } from "@/contexts/ref";
import { useI18n } from "@/shared/hooks";
import { AdSlotIds } from "@/shared/types";
import { Divider } from "@gemini/ui";
import { PartnerBoxWrapper } from "./PartnerBoxWrapper";
import { useShowAds } from "../../hooks/useShowAds";
import { getFeaturesEnabled } from "@/utils";
import { Box, useBreakpointValue } from "@gemini/core";
export const PartnerBoxCommercial = () => {
    const { t } = useI18n();
    const { PartnerBoxCommercialRef } = useRefsContext();
    const { isAllSlotsLoaded, showSection } = useShowAds();
    const { newPartnerLayout } = getFeaturesEnabled();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    const showDivider = isAllSlotsLoaded([
        AdSlotIds.PARTNERBOX_1_COMMERCIAL,
        AdSlotIds.PARTNERBOX_2_COMMERCIAL,
    ]);
    const inlineLayout = newPartnerLayout && !isMobile;
    return (_jsx(_Fragment, { children: _jsx(PartnerBoxWrapper
        // @ts-ignore
        , { 
            // @ts-ignore
            partnerBoxRef: PartnerBoxCommercialRef, title: t("advertising.partner_services.commercial_prio"), display: showSection([
                AdSlotIds.PARTNERBOX_1_COMMERCIAL,
                AdSlotIds.PARTNERBOX_2_COMMERCIAL,
            ])
                ? "block"
                : "none", children: _jsxs(Box, { display: inlineLayout ? "flex" : "block", gap: inlineLayout ? "spacing.20" : "unset", borderRadius: "radius.8", borderColor: "color.border.light.default", borderStyle: inlineLayout ? "none" : "solid", borderWidth: "borderWidth.1", children: [_jsx(Box, { borderRadius: "radius.8", borderColor: "color.border.light.default", borderStyle: inlineLayout ? "solid" : "none", borderWidth: "borderWidth.1", overflow: "hidden", width: "100%", children: _jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_1_COMMERCIAL, width: "100%", height: "min-content" }) }), showDivider && !inlineLayout && _jsx(Divider, {}), _jsx(Box, { borderRadius: "radius.8", borderColor: "color.border.light.default", borderStyle: inlineLayout ? "solid" : "none", borderWidth: "borderWidth.1", overflow: "hidden", width: "100%", children: _jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_2_COMMERCIAL, width: "100%", height: "min-content" }) })] }) }) }));
};
